import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Sitemap from "./pages/Sitemap";
import { ThemeProvider } from "next-themes";
import TermsOfUse from "./pages/TermsOfUse";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";

// Import route groups
import FinancialRoutes from "./routes/FinancialRoutes";
import HealthRoutes from "./routes/HealthRoutes";
import EducationRoutes from "./routes/EducationRoutes";
import LifestyleRoutes from "./routes/LifestyleRoutes";
import ProfessionalRoutes from "./routes/ProfessionalRoutes";

// Run validation only in development environment
if (process.env.NODE_ENV === 'development') {
  import("./lib/utils/calculatorLinkValidator").then(({ logLinkValidationResults }) => {
    logLinkValidationResults();
  });
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light">
        <BrowserRouter>
          <ScrollToTop />
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/sitemap" element={<Sitemap />} />
            
            {/* Category Route Groups */}
            {FinancialRoutes}
            {HealthRoutes}
            {EducationRoutes}
            {LifestyleRoutes}
            {ProfessionalRoutes}
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
